import { api } from "./ApiPromisify";
import { CloudService } from "./ClientLibsReference";
import * as logger from "../Feedback/Log";

export const exceptionCreate = async exceptionRequest => {
  //TODO implement ExceptionAPI
  return { errorCode: 0 };
};

export const customerGetByCodeTag = async businessRequest => {
  let response = "";
  businessRequest.type = "Client";
  logger.info(businessRequest);

  await api("businessApiV1BusinesslistByType", businessRequest).then(res => {
    let businessResponse = CloudService.BusinessResponse.constructFromObject(
      res.data
    );
    logger.info(businessResponse);
    response = businessResponse;
  });
  return response;
};

export const supplierGetByCodeTag = async businessRequest => {
  let response = "";
  businessRequest.type = "Supplier";
  logger.info(businessRequest);

  await api("businessApiV1BusinesslistByType", businessRequest).then(res => {
    let businessResponse = CloudService.BusinessResponse.constructFromObject(
      res.data
    );
    logger.info(businessResponse);
    response = businessResponse;
  });
  return response;
};

export const orderGetByCodeTag = async orderRequest => {
  let response = "";
  logger.info(orderRequest);

  await api("orderApiV1OrderGetByCodeTag", orderRequest).then(res => {
    let orderResponse = CloudService.OrderV2Response.constructFromObject(
      res.data
    );
    logger.info(orderResponse);
    response = orderResponse;
  });
  return response;
};

export const orderUpdate = async orderRequest => {
  let response = "";
  logger.info(orderRequest);

  await api("orderApiV1OrderUpdate", orderRequest).then(res => {
    let orderResponse = CloudService.OrderV2Response.constructFromObject(
      res.data
    );
    logger.info(orderResponse);
    response = orderResponse;
  });
  return response;
};

export const orderCreate = async orderRequest => {
  let response = "";
  logger.info(orderRequest);

  await api("orderApiV1OrderCreate", orderRequest).then(res => {
    let orderResponse = CloudService.OrderV2Response.constructFromObject(
      res.data
    );
    logger.info(orderResponse);
    response = orderResponse;
  });
  return response;
};

export const orderDelete = async orderRequest => {
  let response = "";
  logger.info(orderRequest);

  await api("orderApiV1OrderDelete", orderRequest).then(res => {
    let orderResponse = CloudService.OrderV2Response.constructFromObject(
      res.data
    );
    logger.info(orderResponse);
    response = orderResponse;
  });
  return response;
};

export const deliveryGetByCodeTag = async deliveryRequest => {
  let response = "";
  logger.info(deliveryRequest);

  await api("deliveryApiV1DeliveryGetByCodeTag", deliveryRequest).then(res => {
    let deliveryResponse = CloudService.DeliveryV2Response.constructFromObject(
      res.data
    );
    logger.info(deliveryResponse);
    response = deliveryResponse;
  });
  return response;
};

export const deliveryUpdate = async deliveryRequest => {
  let response = "";
  logger.info(deliveryRequest);

  await api("deliveryApiV1DeliveryUpdate", deliveryRequest).then(res => {
    let deliveryResponse = CloudService.DeliveryV2Response.constructFromObject(
      res.data
    );
    logger.info(deliveryResponse);
    response = deliveryResponse;
  });
  return response;
};

export const deliveryCreate = async deliveryRequest => {
  let response = "";
  logger.info(deliveryRequest);

  await api("deliveryApiV1DeliveryCreate", deliveryRequest).then(res => {
    let deliveryResponse = CloudService.DeliveryV2Response.constructFromObject(
      res.data
    );
    logger.info(deliveryResponse);
    response = deliveryResponse;
  });
  return response;
};

export const deliveryDelete = async deliveryRequest => {
  let response = "";
  logger.info(deliveryRequest);

  await api("deliveryApiV1DeliveryDelete", deliveryRequest).then(res => {
    let deliveryResponse = CloudService.DeliveryV2Response.constructFromObject(
      res.data
    );
    logger.info(deliveryResponse);
    response = deliveryResponse;
  });
  return response;
};

export const workGetByCodeTag = async workRequest => {
  let response = "";
  logger.info(workRequest);

  await api("workApiV1WorkGetByCodeTag", workRequest).then(res => {
    let workResponse = CloudService.WorkV2Response.constructFromObject(
      res.data
    );
    logger.info(workResponse);
    response = workResponse;
  });
  return response;
};

export const workUpdate = async workRequest => {
  let response = "";
  logger.info(workRequest);

  await api("workApiV1WorkUpdate", workRequest).then(res => {
    let workResponse = CloudService.WorkV2Response.constructFromObject(
      res.data
    );
    logger.info(workResponse);
    response = workResponse;
  });
  return response;
};

export const workCreate = async workRequest => {
  let response = "";
  logger.info(workRequest);

  await api("workApiV1WorkCreate", workRequest).then(res => {
    let workResponse = CloudService.WorkV2Response.constructFromObject(
      res.data
    );
    logger.info(workResponse);
    response = workResponse;
  });
  return response;
};

export const workDelete = async workRequest => {
  let response = "";
  logger.info(workRequest);

  await api("workApiV1WorkDelete", workRequest).then(res => {
    let workResponse = CloudService.WorkV2Response.constructFromObject(
      res.data
    );
    logger.info(workResponse);
    response = workResponse;
  });
  return response;
};

export const workItemGetByCodeTag = async workItemRequest => {
  let response = "";
  logger.info(workItemRequest);

  await api("workItemApiV1WorkItemGetByCodeTag", workItemRequest).then(res => {
    let workItemResponse = CloudService.WorkItemV2Response.constructFromObject(
      res.data
    );
    logger.info(workItemResponse);
    response = workItemResponse;
  });
  return response;
};

export const workItemGetByWorkId = async workItemRequest => {
  let response = "";
  logger.info(workItemRequest);

  await api("workItemApiV1WorkItemGetByWorkId", workItemRequest).then(res => {
    let workItemResponse = CloudService.WorkItemV2Response.constructFromObject(
      res.data
    );
    logger.info(workItemResponse);
    response = workItemResponse;
  });
  return response;
};

export const workItemUpdate = async workItemRequest => {
  let response = "";
  logger.info(workItemRequest);

  await api("workItemApiV1WorkItemUpdate", workItemRequest).then(res => {
    let workItemResponse = CloudService.WorkItemV2Response.constructFromObject(
      res.data
    );
    logger.info(workItemResponse);
    response = workItemResponse;
  });
  return response;
};

export const workItemCreate = async workItemRequest => {
  let response = "";
  logger.info(workItemRequest);

  await api("workItemApiV1WorkItemCreate", workItemRequest).then(res => {
    let workItemResponse = CloudService.WorkItemV2Response.constructFromObject(
      res.data
    );
    logger.info(workItemResponse);
    response = workItemResponse;
  });
  return response;
};

export const workItemDelete = async workItemRequest => {
  let response = "";
  logger.info(workItemRequest);

  await api("workItemApiV1WorkItemDelete", workItemRequest).then(res => {
    let workItemResponse = CloudService.WorkItemV2Response.constructFromObject(
      res.data
    );
    logger.info(workItemResponse);
    response = workItemResponse;
  });
  return response;
};

export const partGetByCodeTag = async partRequest => {
  let response = "";
  logger.info(partRequest);

  await api("partApiV1PartGetByCodeTag", partRequest).then(res => {
    let partResponse = CloudService.PartResponse.constructFromObject(res.data);
    logger.info(partResponse);
    response = partResponse;
  });
  return response;
};

export const partUpdate = async partRequest => {
  let response = "";
  logger.info(partRequest);

  await api("partApiV1PartUpdate", partRequest).then(res => {
    let partResponse = CloudService.PartResponse.constructFromObject(res.data);
    logger.info(partResponse);
    response = partResponse;
  });
  return response;
};

export const partCreate = async partRequest => {
  let response = "";
  logger.info(partRequest);

  await api("partApiV1PartCreate", partRequest).then(res => {
    let partResponse = CloudService.PartResponse.constructFromObject(res.data);
    logger.info(partResponse);
    response = partResponse;
  });
  return response;
};

export const partDelete = async partRequest => {
  let response = "";
  logger.info(partRequest);

  await api("partApiV1PartDelete", partRequest).then(res => {
    let partResponse = CloudService.PartResponse.constructFromObject(res.data);
    logger.info(partResponse);
    response = partResponse;
  });
  return response;
};

export const productGetByCodeTag = async productRequest => {
  let response = "";
  logger.info(productRequest);

  await api("productApiV1ProductGetByCodeTag", productRequest).then(res => {
    let productResponse = CloudService.ProductResponse.constructFromObject(
      res.data
    );
    logger.info(productResponse);
    response = productResponse;
  });
  return response;
};

export const productGetByIdAndFlow = async productRequest => {
  let response = "";
  logger.info(productRequest);

  await api("productApiV1ProductGetByIdAndFlow", productRequest).then(res => {
    let productResponse = CloudService.ProductResponse.constructFromObject(
      res.data
    );
    logger.info(productResponse);
    response = productResponse;
  });
  return response;
};
export const productGetById = async productRequest => {
  let response = "";
  logger.info(productRequest);

  await api("productApiV1ProductGetById", productRequest).then(res => {
    let productResponse = CloudService.ProductResponse.constructFromObject(
      res.data
    );
    logger.info(productResponse);
    response = productResponse;
  });
  return response;
};
export const partGetByIdAndFlow = async partRequest => {
  let response = "";
  logger.info(partRequest);

  await api("partApiV1PartGetByIdAndFlow", partRequest).then(res => {
    let partResponse = CloudService.PartResponse.constructFromObject(res.data);
    logger.info(partResponse);
    response = partResponse;
  });
  return response;
};

export const productUpdate = async productRequest => {
  let response = "";
  logger.info(productRequest);

  await api("productApiV1ProductUpdate", productRequest).then(res => {
    let productResponse = CloudService.ProductResponse.constructFromObject(
      res.data
    );
    logger.info(productResponse);
    response = productResponse;
  });
  return response;
};

export const productCreate = async productRequest => {
  let response = "";
  logger.info(productRequest);

  await api("productApiV1ProductCreate", productRequest).then(res => {
    let productResponse = CloudService.ProductResponse.constructFromObject(
      res.data
    );
    logger.info(productResponse);
    response = productResponse;
  });
  return response;
};

export const productDelete = async productRequest => {
  let response = "";
  logger.info(productRequest);

  await api("productApiV1ProductDelete", productRequest).then(res => {
    let productResponse = CloudService.ProductResponse.constructFromObject(
      res.data
    );
    logger.info(productResponse);
    response = productResponse;
  });
  return response;
};

export const attributeGetByCodeTag = async attributeRequest => {
  let response = "";
  logger.info(attributeRequest);

  await api("attributeApiV1AttributeGetByCodeTag", attributeRequest).then(
    res => {
      if (res.data.attributeList) {
      }
      let attributeResponse = CloudService.AttributeResponse.constructFromObject(
        res.data
      );
      logger.info(attributeResponse);
      response = attributeResponse;
    }
  );
  return response;
};

export const attributeUpdate = async attributeRequest => {
  let response = "";
  logger.info(attributeRequest);

  await api("attributeApiV1AttributeUpdate", attributeRequest).then(res => {
    let attributeResponse = CloudService.AttributeResponse.constructFromObject(
      res.data
    );
    logger.info(attributeResponse);
    response = attributeResponse;
  });
  return response;
};

export const attributeCreate = async attributeRequest => {
  let response = "";
  logger.info(attributeRequest);

  await api("attributeApiV1AttributeCreate", attributeRequest).then(res => {
    let attributeResponse = CloudService.AttributeResponse.constructFromObject(
      res.data
    );
    logger.info(attributeResponse);
    response = attributeResponse;
  });
  return response;
};

export const attributeDelete = async attributeRequest => {
  let response = "";
  logger.info(attributeRequest);

  await api("attributeApiV1AttributeDelete", attributeRequest).then(res => {
    let attributeResponse = CloudService.AttributeResponse.constructFromObject(
      res.data
    );
    logger.info(attributeResponse);
    response = attributeResponse;
  });
  return response;
};

export const attributeSetGetByCodeTag = async attributeSetRequest => {
  let response = "";
  logger.info(attributeSetRequest);

  await api(
    "attributeSetApiV1AttributeSetGetByCodeTag",
    attributeSetRequest
  ).then(res => {
    let attributeSetResponse = CloudService.AttributeSetResponse.constructFromObject(
      res.data
    );
    logger.info(attributeSetResponse);
    response = attributeSetResponse;
  });
  return response;
};

export const attributeSetUpdate = async attributeSetRequest => {
  let response = "";
  logger.info(attributeSetRequest);

  await api("attributeSetApiV1AttributeSetUpdate", attributeSetRequest).then(
    res => {
      let attributeSetResponse = CloudService.AttributeSetResponse.constructFromObject(
        res.data
      );
      logger.info(attributeSetResponse);
      response = attributeSetResponse;
    }
  );
  return response;
};

export const attributeSetCreate = async attributeSetRequest => {
  let response = "";
  logger.info(attributeSetRequest);

  await api("attributeSetApiV1AttributeSetCreate", attributeSetRequest).then(
    res => {
      let attributeSetResponse = CloudService.AttributeSetResponse.constructFromObject(
        res.data
      );
      logger.info(attributeSetResponse);
      response = attributeSetResponse;
    }
  );
  return response;
};

export const attributeSetDelete = async attributeSetRequest => {
  let response = "";
  logger.info(attributeSetRequest);

  await api("attributeSetApiV1AttributeSetDelete", attributeSetRequest).then(
    res => {
      let attributeSetResponse = CloudService.AttributeSetResponse.constructFromObject(
        res.data
      );
      logger.info(attributeSetResponse);
      response = attributeSetResponse;
    }
  );
  return response;
};

export const catalogueGetByCodeTag = async catalogueRequest => {
  let response = "";
  logger.info(catalogueRequest);

  await api("catalogueApiV1CatalogueGetByCodeTag", catalogueRequest).then(
    res => {
      let catalogueResponse = CloudService.CatalogueResponse.constructFromObject(
        res.data
      );
      logger.info(catalogueResponse);
      response = catalogueResponse;
    }
  );
  return response;
};

export const catalogueUpdate = async catalogueRequest => {
  let response = "";
  logger.info(catalogueRequest);

  await api("catalogueApiV1CatalogueUpdate", catalogueRequest).then(res => {
    let catalogueResponse = CloudService.CatalogueResponse.constructFromObject(
      res.data
    );
    logger.info(catalogueResponse);
    response = catalogueResponse;
  });
  return response;
};

export const catalogueCreate = async catalogueRequest => {
  let response = "";
  logger.info(catalogueRequest);

  await api("catalogueApiV1CatalogueCreate", catalogueRequest).then(res => {
    let catalogueResponse = CloudService.CatalogueResponse.constructFromObject(
      res.data
    );
    logger.info(catalogueResponse);
    response = catalogueResponse;
  });
  return response;
};

export const catalogueDelete = async catalogueRequest => {
  let response = "";
  logger.info(catalogueRequest);

  await api("catalogueApiV1CatalogueDelete", catalogueRequest).then(res => {
    let catalogueResponse = CloudService.CatalogueResponse.constructFromObject(
      res.data
    );
    logger.info(catalogueResponse);
    response = catalogueResponse;
  });
  return response;
};

export const categoryGetByCatalogueId = async categoryRequest => {
  let response = "";
  logger.info(categoryRequest);

  await api("categoryApiV1CategoryGetByCatalogueId", categoryRequest).then(
    res => {
      let categoryResponse = CloudService.CategoryResponse.constructFromObject(
        res.data
      );
      logger.info(categoryResponse);
      response = categoryResponse;
    }
  );
  return response;
};

export const categoryUpdate = async categoryRequest => {
  let response = "";
  logger.info(categoryRequest);

  await api("categoryApiV1CategoryUpdate", categoryRequest).then(res => {
    let categoryResponse = CloudService.CategoryResponse.constructFromObject(
      res.data
    );
    logger.info(categoryResponse);
    response = categoryResponse;
  });
  return response;
};

export const categoryCreate = async categoryRequest => {
  let response = "";
  logger.info(categoryRequest);

  await api("categoryApiV1CategoryCreate", categoryRequest).then(res => {
    let categoryResponse = CloudService.CategoryResponse.constructFromObject(
      res.data
    );
    logger.info(categoryResponse);
    response = categoryResponse;
  });
  return response;
};

export const categoryDelete = async categoryRequest => {
  let response = "";
  logger.info(categoryRequest);

  await api("categoryApiV1CategoryDelete", categoryRequest).then(res => {
    let categoryResponse = CloudService.CategoryResponse.constructFromObject(
      res.data
    );
    logger.info(categoryResponse);
    response = categoryResponse;
  });
  return response;
};

export const stationGetByCodeTag = async stationRequest => {
  let response = "";
  logger.info(stationRequest);

  await api("stationApiV1StationGetByCodeTag", stationRequest).then(res => {
    let stationResponse = CloudService.StationResponse.constructFromObject(
      res.data
    );
    logger.info(stationResponse);
    response = stationResponse;
  });
  return response;
};

export const stationGetByKanbanId = async stationRequest => {
  let response = "";
  logger.info(stationRequest);

  await api("stationApiV1StationGetByIdKanban", stationRequest).then(res => {
    let stationResponse = CloudService.StationResponse.constructFromObject(
      res.data
    );
    logger.info(stationResponse);
    response = stationResponse;
  });
  return response;
};

export const stationGetByCodeTagKanban = async stationRequest => {
  let response = "";
  logger.info(stationRequest);

  await api("stationApiV1StationGetAllByCodeTagKanban", stationRequest).then(
    res => {
      let stationResponse = CloudService.StationResponse.constructFromObject(
        res.data
      );
      logger.info(stationResponse);
      response = stationResponse;
    }
  );
  return response;
};

export const stationUpdateByKanban = async stationRequest => {
  let response = "";
  logger.info(stationRequest);

  await api("stationApiV1StationUpdateByIdKanban", stationRequest).then(res => {
    let stationResponse = CloudService.StationResponse.constructFromObject(
      res.data
    );
    logger.info(stationResponse);
    response = stationResponse;
  });
  return response;
};

export const stationUpdate = async stationRequest => {
  let response = "";
  logger.info(stationRequest);

  await api("stationApiV1StationUpdate", stationRequest).then(res => {
    let stationResponse = CloudService.StationResponse.constructFromObject(
      res.data
    );
    logger.info(stationResponse);
    response = stationResponse;
  });
  return response;
};

export const stationCreate = async stationRequest => {
  let response = "";
  logger.info(stationRequest);

  await api("stationApiV1StationCreate", stationRequest).then(res => {
    let stationResponse = CloudService.StationResponse.constructFromObject(
      res.data
    );
    logger.info(stationResponse);
    response = stationResponse;
  });
  return response;
};

export const stationDelete = async stationRequest => {
  let response = "";
  logger.info(stationRequest);

  await api("stationApiV1StationDelete", stationRequest).then(res => {
    let stationResponse = CloudService.StationResponse.constructFromObject(
      res.data
    );
    logger.info(stationResponse);
    response = stationResponse;
  });
  return response;
};

export const flowGetByCodeTag = async flowRequest => {
  let response = "";
  logger.info(flowRequest);

  await api("flowApiV1FlowGetByCodeTag", flowRequest).then(res => {
    let flowResponse = CloudService.FlowResponse.constructFromObject(res.data);
    logger.info(flowResponse);
    response = flowResponse;
  });
  return response;
};

export const flowGetByEntityIdAndType = async flowRequest => {
  let response = "";
  logger.info(flowRequest);

  await api("flowApiV1FlowGetByEntityTypeAndEntityId", flowRequest).then(
    res => {
      let flowResponse = CloudService.FlowResponse.constructFromObject(
        res.data
      );
      logger.info(flowResponse);
      response = flowResponse;
    }
  );
  return response;
};

export const flowUpdate = async flowRequest => {
  let response = "";
  logger.info(flowRequest);

  await api("flowApiV1FlowUpdate", flowRequest).then(res => {
    let flowResponse = CloudService.FlowResponse.constructFromObject(res.data);
    logger.info(flowResponse);
    response = flowResponse;
  });
  return response;
};

export const flowCreate = async flowRequest => {
  let response = "";
  logger.info(flowRequest);

  await api("flowApiV1FlowCreate", flowRequest).then(res => {
    let flowResponse = CloudService.FlowResponse.constructFromObject(res.data);
    logger.info(flowResponse);
    response = flowResponse;
  });
  return response;
};

export const flowDelete = async flowRequest => {
  let response = "";
  logger.info(flowRequest);

  await api("flowApiV1FlowDelete", flowRequest).then(res => {
    let flowResponse = CloudService.FlowResponse.constructFromObject(res.data);
    logger.info(flowResponse);
    response = flowResponse;
  });
  return response;
};

export const buildingGetBySiteId = async buildingRequest => {
  let response = "";
  logger.info(buildingRequest);

  await api("buildingApiV1BuildingGetBySiteId", buildingRequest).then(res => {
    let buildingResponse = CloudService.BuildingResponse.constructFromObject(
      res.data
    );
    logger.info(buildingResponse);
    response = buildingResponse;
  });
  return response;
};

export const locationGetByBuildingId = async locationRequest => {
  let response = "";
  logger.info(locationRequest);

  await api("locationApiV1LocationV2GetByBuildingId", locationRequest).then(
    res => {
      let locationResponse = CloudService.LocationV2Response.constructFromObject(
        res.data
      );
      logger.info(locationResponse);
      response = locationResponse;
    }
  );
  return response;
};
export const locationGetByClientId = async locationRequest => {
  let response = "";
  logger.info(locationRequest);

  await api("locationApiV1LocationV2GetByClientId", locationRequest).then(
    res => {
      let locationResponse = CloudService.LocationResponse.constructFromObject(
        res.data
      );
      logger.info(locationResponse);
      response = locationResponse;
    }
  );
  return response;
};

export const siteUpdate = async siteRequest => {
  let response = "";
  logger.info(siteRequest);

  await api("siteApiV1SiteUpdate", siteRequest).then(res => {
    let siteResponse = CloudService.SiteV2Response.constructFromObject(
      res.data
    );
    logger.info(siteResponse);
    response = siteResponse;
  });
  return response;
};

export const siteCreate = async siteRequest => {
  let response = "";
  logger.info(siteRequest);

  await api("siteApiV1SiteCreate", siteRequest).then(res => {
    let siteResponse = CloudService.SiteV2Response.constructFromObject(
      res.data
    );
    logger.info(siteResponse);
    response = siteResponse;
  });
  return response;
};

export const siteDelete = async siteRequest => {
  let response = "";
  logger.info(siteRequest);

  await api("siteApiV1SiteDelete", siteRequest).then(res => {
    let siteResponse = CloudService.SiteV2Response.constructFromObject(
      res.data
    );
    logger.info(siteResponse);
    response = siteResponse;
  });
  return response;
};

export const siteGetByCodeTag = async siteRequest => {
  let response = "";
  logger.info(siteRequest);

  await api("siteApiV1SiteGetByCodeTag", siteRequest).then(res => {
    let siteResponse = CloudService.SiteV2Response.constructFromObject(
      res.data
    );
    logger.info(siteResponse);
    response = siteResponse;
  });
  return response;
};

export const siteGetByClientId = async siteRequest => {
  let response = "";
  logger.info(siteRequest);

  await api("siteApiV1SiteGetByClientId", siteRequest).then(res => {
    let siteResponse = CloudService.SiteV2Response.constructFromObject(
      res.data
    );
    logger.info(siteResponse);
    response = siteResponse;
  });
  return response;
};

export const locationUpdate = async locationRequest => {
  let response = "";
  logger.info(locationRequest);

  await api("locationApiV1LocationUpdate", locationRequest).then(res => {
    let locationResponse = CloudService.LocationV2Response.constructFromObject(
      res.data
    );
    logger.info(locationResponse);
    response = locationResponse;
  });
  return response;
};

export const locationCreate = async locationRequest => {
  let response = "";
  logger.info(locationRequest);

  await api("locationApiV1LocationCreate", locationRequest).then(res => {
    let locationResponse = CloudService.LocationV2Response.constructFromObject(
      res.data
    );
    logger.info(locationResponse);
    response = locationResponse;
  });
  return response;
};

export const locationDelete = async locationRequest => {
  let response = "";
  logger.info(locationRequest);

  await api("locationApiV1LocationDelete", locationRequest).then(res => {
    let locationResponse = CloudService.LocationV2Response.constructFromObject(
      res.data
    );
    logger.info(locationResponse);
    response = locationResponse;
  });
  return response;
};

export const buildingUpdate = async buildingRequest => {
  let response = "";
  logger.info(buildingRequest);

  await api("buildingApiV1BuildingUpdate", buildingRequest).then(res => {
    let buildingResponse = CloudService.BuildingV2Response.constructFromObject(
      res.data
    );
    logger.info(buildingResponse);
    response = buildingResponse;
  });
  return response;
};

export const buildingCreate = async buildingRequest => {
  let response = "";
  logger.info(buildingRequest);

  await api("buildingApiV1BuildingCreate", buildingRequest).then(res => {
    let buildingResponse = CloudService.BuildingV2Response.constructFromObject(
      res.data
    );
    logger.info(buildingResponse);
    response = buildingResponse;
  });
  return response;
};

export const buildingDelete = async buildingRequest => {
  let response = "";
  logger.info(buildingRequest);

  await api("buildingApiV1BuildingDelete", buildingRequest).then(res => {
    let buildingResponse = CloudService.BuildingV2Response.constructFromObject(
      res.data
    );
    logger.info(buildingResponse);
    response = buildingResponse;
  });
  return response;
};

export const statisticsCreate = async request => {
  let response = "";
  logger.info(request);

  await api("statisticsApiV1StatisticsCreate", request).then(res => {
    let statResponse = CloudService.StatisticsResponse.constructFromObject(
      res.data
    );
    logger.info(statResponse);
    response = statResponse;
  });
  return response;
};

export const userCreate = async request => {
  let response = "";
  logger.info(request);

  await api("userApiV1UserCreate", request).then(res => {
    let userResponse = CloudService.UserResponse.constructFromObject(res.data);
    logger.info(userResponse);
    response = userResponse;
  });

  return response;
};

export const userDelete = async request => {
  let response = "";
  logger.info(request);

  await api("userApiV1UserDelete", request).then(res => {
    let userResponse = CloudService.UserResponse.constructFromObject(res.data);
    logger.info(userResponse);
    response = userResponse;
  });

  return response;
};

export const userUpdate = async request => {
  let response = "";
  logger.info(request);

  await api("userApiV1UserUpdateAccount", request).then(res => {
    let userResponse = CloudService.UserResponse.constructFromObject(res.data);
    logger.info(userResponse);
    response = userResponse;
  });

  return response;
};

export const userListInBusiness = async request => {
  let response = "";
  logger.info(request);

  await api("userApiV1UserListInBusiness", request).then(res => {
    let userResponse = CloudService.UserResponse.constructFromObject(res.data);
    logger.info(userResponse);
    response = userResponse;
  });

  return response;
};

export const supplierCreate = async request => {
  let response = "";
  logger.info(request);

  await api("businessApiV1CreateBusinessWithParent", request).then(res => {
    let businessResponse = CloudService.BusinessResponse.constructFromObject(
      res.data
    );
    logger.info(businessResponse);
    response = businessResponse;
  });

  return response;
};

export const supplierDelete = async request => {
  let response = "";
  logger.info(request);

  await api("businessApiV1SoftEraseBusiness", request).then(res => {
    let businessResponse = CloudService.BusinessResponse.constructFromObject(
      res.data
    );
    logger.info(businessResponse);
    response = businessResponse;
  });

  return response;
};

export const supplierUpdate = async request => {
  let response = "";
  logger.info(request);

  await api("businessApiV1BusinessUpdate", request).then(res => {
    let businessResponse = CloudService.BusinessResponse.constructFromObject(
      res.data
    );
    logger.info(businessResponse);
    response = businessResponse;
  });

  return response;
};

export const businessListByType = async request => {
  let response = "";
  logger.info(request);

  await api("businessApiV1BusinessListByParentKeyAndType", request).then(
    res => {
      let businessResponse = CloudService.BusinessResponse.constructFromObject(
        res.data
      );
      logger.info(businessResponse);
      response = businessResponse;
    }
  );

  return response;
};

export const customerCreate = async request => {
  let response = "";
  logger.info(request);

  await api("businessApiV1CreateBusinessWithParent", request).then(res => {
    let businessResponse = CloudService.BusinessResponse.constructFromObject(
      res.data
    );
    logger.info(businessResponse);
    response = businessResponse;
  });

  return response;
};

export const customerDelete = async request => {
  let response = "";
  logger.info(request);

  await api("businessApiV1SoftEraseBusiness", request).then(res => {
    let businessResponse = CloudService.BusinessResponse.constructFromObject(
      res.data
    );
    logger.info(businessResponse);
    response = businessResponse;
  });

  return response;
};

export const customerUpdate = async request => {
  let response = "";
  logger.info(request);

  await api("businessApiV1BusinessUpdate", request).then(res => {
    let businessResponse = CloudService.BusinessResponse.constructFromObject(
      res.data
    );
    logger.info(businessResponse);
    response = businessResponse;
  });

  return response;
};

export const invoiceCreate = async request => {
  let response = "";
  logger.info(request);

  await api("invoiceApiV1InvoiceCreate", request).then(res => {
    let invoiceResponse = CloudService.InvoiceResponse.constructFromObject(
      res.data
    );
    logger.info(invoiceResponse);
    response = invoiceResponse;
  });

  return response;
};

export const invoiceDelete = async request => {
  let response = "";
  logger.info(request);

  await api("invoiceApiV1InvoiceDelete", request).then(res => {
    let invoiceResponse = CloudService.InvoiceResponse.constructFromObject(
      res.data
    );
    logger.info(invoiceResponse);
    response = invoiceResponse;
  });

  return response;
};

export const invoiceUpdate = async request => {
  let response = "";
  logger.info(request);

  await api("invoiceApiV1InvoiceUpdate", request).then(res => {
    let invoiceResponse = CloudService.InvoiceResponse.constructFromObject(
      res.data
    );
    logger.info(invoiceResponse);
    response = invoiceResponse;
  });

  return response;
};

export const invoiceGetByCodeTag = async request => {
  let response = "";
  logger.info(request);

  await api("invoiceApiV1InvoiceGetByCodeTag", request).then(res => {
    let invoiceResponse = CloudService.InvoiceResponse.constructFromObject(
      res.data
    );
    logger.info(invoiceResponse);
    response = invoiceResponse;
  });

  return response;
};



// WEBPACK FOOTER //
// ./src/common/CloudService/ApiService.js